import { ICON } from '@/constants/icons';
import { qx_ePrivilege_enum } from '@/graphql/types';
import { ConfigRouteObject } from '@/types';

/**
 * Registered as a sibling of `SENSOR_VIEW_ROUTE` under the sensors route tree ([routes.ts](src/views/sensors/routes.ts)):
 * zones are masked as sensors in the nav/list (Zone Plan B), so their detail view lives alongside
 * the sensor detail rather than under `/intrusion`.
 */
export const ZONE_VIEW_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.SENSOR],
  UI_LABEL: 'View Zone',
  ROUTE_PATH: 'zones/:zoneId',
  ROUTE_NAME: 'zone.view',
  ROUTE_PARAM: 'zoneId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const ZONE_VIEW_INFO_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.CIRCLE_INFO],
  UI_LABEL: 'Info',
  ROUTE_PATH: '',
  ROUTE_NAME: ZONE_VIEW_ROUTE.ROUTE_NAME,
  ROUTE_PARAM: 'zoneId',
  PRIVILEGES: [qx_ePrivilege_enum.DeviceView]
};

export const ZONE_EDIT_ROUTE: ConfigRouteObject = {
  UI_ICON: ['fas', ICON.EDIT],
  UI_LABEL: 'Edit',
  ROUTE_PATH: 'edit',
  ROUTE_NAME: 'zone.edit',
  ROUTE_PARAM: 'zoneId',
  PRIVILEGES: [qx_ePrivilege_enum.IntrusionConfig]
};
